import { getRandomArbitrary } from 'Utils'
export default {
  toggleDraggingClass(event) {
    const parent = event.target
    parent.classList.toggle('dragging')
  },
  /**
   * Get Closest Elements
   *
   * Will return previous and next elements on array based on
   * the current element's index
   *
   * @param {Object} element Element to compare.
   * @param {Array} listing Element's parent to look for closest sibilings.
   *
   * @returns {Object} previous & next element's sibilings.
   */
  getClosestElements(element, listing) {
    return {
      previous: listing.indexOf(element) - 1 < 0 ? undefined : listing.indexOf(element) - 1,
      next:
        listing.indexOf(element) + 1 >= listing.length ? undefined : listing.indexOf(element) + 1,
    }
  },
  /**
   * Calculate Order
   *
   * Will calculate new element's order based on previous and
   * next element sibiling.
   *
   * @param {String|Number} prevElementOrder The previous element order.
   * @param {String|Number} nextElementOrder The next element order.
   *
   * @returns {Number} new element's order.
   */
  calculateOrder(prevElementOrder, nextElementOrder) {
    const previous = (parseFloat(prevElementOrder) * 100) / 100
    const next = (parseFloat(nextElementOrder) * 100) / 100
    let order = 0
    // Item first place
    if (!previous && next) {
      // console.log('frist place ⤵')
      order = (next - 1 + next) / 2
      order = getRandomArbitrary(order, next)
    }
    // Item between
    else if (previous && next) {
      // console.log('item between ⤵')
      order = (previous + next) / 2
      order = getRandomArbitrary(order, next)
    }
    // Item last place
    else if (previous && !next) {
      // console.log('item last place ⤵')
      order = (previous + 1 + previous) / 2
      order = getRandomArbitrary(order, previous)
    }
    // no sibilings
    else if (!previous && !next) {
      // console.log('no next no prev ⤵')
      order = 1
    }
    return order.toFixed(10)
  },

  /**
   * Get Element New Order
   *
   * Will calculate the new element's order based on it's possition and its
   * sibilings inside the listing.
   *
   * @param {Object} event Current item's event object from where to get its
   *                       parent and sibilings.
   * @param {String} type  The current item's type, this case: 'checklist' or 'item'
   *
   * @returns {Object}     The item's vue instance and its order
   */
  getElementNewOrder: function (event, type) {
    const sortable = event.item
    const parent = event.target
    // const selectorQuery = sortable.getAttribute('data-id')
    const draggableElements =
      type === 'checklist'
        ? [...parent.querySelectorAll(`.checklist:not(.sortable-drag)`)]
        : [...parent.querySelectorAll(`.checklist__item:not(.sortable-drag)`)]
    // getting closests elements
    const { previous, next } = this.getClosestElements(sortable, draggableElements)
    // converting to vue
    const sortableItem = sortable.__vue__
    const previousItem = draggableElements[previous]?.__vue__
    const nextItem = draggableElements[next]?.__vue__
    // getting new element's order
    let newElementOrder
    if (type === 'checklist') {
      newElementOrder = this.calculateOrder(
        previousItem?.checklist.order,
        nextItem?.checklist.order
      )
    } else if (type === 'item') {
      newElementOrder = this.calculateOrder(previousItem?.item.order, nextItem?.item.order)
    }
    return { sortableItem, newElementOrder }
  },
}
